import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { User } from '../models/user.model';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
  roles = ['patient', 'doctor']
  user: User = {uid: '', email: '', address: '', phone: '', role: '', country: '', name: '', state: '', password: ''};
  constructor(private userService: UserService) { }

  ngOnInit(): void {
  }

  async signUp(){
    console.log(this.user);
    await this.userService.createUser(this.user).then(() => {
      console.log("done")
    });
  }

}
